export default __webpack_public_path__ + "static/media/9December.869a7a78.svg";